var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("You do not have permission to access this application")]),_c('h2',[_vm._v("Please contact your system administrator")])])
}]

export { render, staticRenderFns }